import { gql } from '@apollo/client';


export const REMOVE_SCALES_FROM_SIZE_AND_WEIGHT = gql`
mutation removeScaleFromSizeAndWeight($input: RemoveScaleFromSizeAndWeightInput!) {
  removeScaleFromSizeAndWeight(input: $input) {
    clientMutationId
    errors
  }
}
`